import { SravniOrganizationsSharedOrganizationType } from '../__generated__/news/Api';
import { IOrgMeta } from '../interfaces/organizations';

import { ProxyClient } from './client/ProxyClient';

export const getOrgByAlias = async (params: { type: SravniOrganizationsSharedOrganizationType; alias: string }) => {
  const { data } = await ProxyClient.get<IOrgMeta>(`/organizations/${params.type}/${params.alias}`);
  return data;
};
